import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/login/Login'
import Home from '@/views/home/Home'
import Analyze from '@/views/systemFunc/project/projectIndex/projectFunc/Analyze'
import Analyzer from '@/views/systemFunc/userFunc/userControl/Analyzer'
import Group from '@/views/systemFunc/project/projectIndex/projectFunc/Group'
import Manager from '@/views/systemFunc/userFunc/userControl/Manager'
import Sale from '@/views/systemFunc/userFunc/userControl/Sale'
import Project from '@/views/systemFunc/project/Project'
import UserHome from '@/views/systemFunc/userFunc/UserHome'
import ProjectIndex from '@/views/systemFunc/project/projectIndex/projectIndex'
import Desc from '@/views/systemFunc/project/projectIndex/projectFunc/Desc'
import Sample from '@/views/systemFunc/project/projectIndex/projectFunc/Sample'
import AnalyzeContentHome from "@/views/systemFunc/analyze/AnalyzeContentHome";
import AnalyzeContent from "@/views/systemFunc/analyze/analyzeInfo/AnalyzeContent";
import ErrModule from "@/views/systemFunc/analyze/analyzeInfo/ErrModule";
import Log from '@/views/systemFunc/log/Log'
import AnalyzeInformation from "@/views/systemFunc/analyze/analyzeInfo/AnalyzeInformation";
import References from '@/views/references/References'
import AddAnalyze from "@/views/systemFunc/project/projectIndex/projectFunc/AddAnalyze";
import Customer from '@/views/systemFunc/userFunc/userControl/Customer'
import RawData from '@/views/systemFunc/project/projectIndex/projectFunc/RawData'
import DataAuditor from "@/views/systemFunc/userFunc/userControl/DataAuditor";
import Questionnaire from "@/views/systemFunc/project/projectIndex/projectFunc/Questionnaire";
import Command from "@/views/systemFunc/command/index";
import Display from "@/components/Display";
import Thanks from "@/components/Thanks";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    children: [

      {
        path: '/projectHome',
        component: ProjectIndex,
        redirect: '/desc',
        children: [
          {path: '/desc', component: Desc},
          {path: '/simpleFile', component: Sample},
          {path: '/groupFile', component: Group},
          {path: '/analyze', component: Analyze},
          {path: '/addAnalyze', component: AddAnalyze},
          {path: '/log1', component: Log},
          {path: '/rawData', component: RawData},

        ]
      },
      {
        path: '/userHome',
        component: UserHome,
        redirect: '/sampleUpload',
        children: [
          {path: '/manager', component: Manager},
          {path: '/analyzer', component: Analyzer},
          {path: '/saler', component: Sale},
          {path: '/customer', component: Customer},
          {path: '/sampleUpload', component: Project},
          {path: '/auditor', component: DataAuditor},
          {path: '/log', component: Log},
          {path: '/questionnaire', component: Questionnaire},
          {path: '/display', component: Display,meta:{activeMenu:'/questionnaire'}},
          {path: '/command', component: Command},
          {path: '/thanks', component: Thanks}
        ]
      },
      {
        path: "/contentAnalyzeHome",
        component: AnalyzeContentHome,
        children: [
          {path: '/analyzeContent', component: AnalyzeContent},
          {path: '/errModule', component:ErrModule},
          {path: '/analyzeInformation', component:AnalyzeInformation},
        ]
      },

    ]
  },
  {path: '/login', component: Login},
  {path: "/ref", component: References},
  // {path: "/test", component: test},

]

const router = new VueRouter({
  base: "/metabolome_16s",
  routes,
  mode:'history' ,  /*hash*/ /*不显示路由中的#*/
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
